
import Vue from 'vue'
import ContactForm from './contactForm.vue'
import ContactStub from './contactStub.vue'
import Contact from './contact'

export default Vue.extend({
    components: {
        ContactForm, ContactStub
    },
    props: {
        contacts: Array as ()=> Array<Contact>
    },
    data() {
        return {
            displayForm: false,
            selectedContact: null as Contact,
            displayTitle: '',
            contactEmail: ''
        }
    },
    computed: {
        groupedByDept: function () {
            return this.contacts.reduce((g: any, c: Contact ) => {
                g[c.parentDeptTitle] = g[c.parentDeptTitle] || [];
                g[c.parentDeptTitle].push(c);
                return g;
            },{});
        }
    },
    methods: {
        displayContactForm: function (contact: Contact) {
            // this.displayTitle = displayTitle;
            // this.contactEmail = contactEmail;
            this.selectedContact = contact;
            this.displayForm = true;
        }
    }
})
